<div
  mat-dialog-title
  appDraggableDialog
  draggableKey="change-color"
  [draggableWithRestrictArea]="true"
  dialogClass=".q9-change-color">
  <span>{{ 'ASIDE_R.FILL_COLOR' | translate }}</span>
</div>

<mat-dialog-content>
  <app-color-picker
    [noMenu]="true"
    [palette]="palette"
    (colorPicked)="changeBackgroundColor($event)"></app-color-picker>
</mat-dialog-content>
